
import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
    Box,
    Chip,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Tooltip,
} from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";

const EnderecoFiscal = () => {
    const navigate = useNavigate();

    const [enderecos, setEnderecos] = useState([]);
    const [editando, setEditando] = useState(null);
    const [dadosEdicao, setDadosEdicao] = useState({});

    useEffect(() => {
        const getEnderecoFiscal = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/get/enderecosFiscais`, {
                    headers: {
                        Authorization: localStorage.getItem("token")
                    }
                });

                if (response.status === 200) {
                    console.log("Endereços fiscais:", response.data);
                    setEnderecos(response.data.enderecosFiscais);
                }
            } catch (error) {
                console.error("Erro ao buscar endereços fiscais:", error);
            }
        }

        getEnderecoFiscal();
    }, [editando, navigate]);



    const iniciarEdicao = (endereco) => {
        setEditando(endereco.idEnderecoFiscal);

        setDadosEdicao({
            ...endereco,
        });
    };

    const cancelarEdicao = () => {
        setEditando(null);
        setDadosEdicao({});
    };

    const alterarCampo = (campo, valor) => {
        setDadosEdicao((prev) => ({
            ...prev,
            [campo]: valor,
        }));
    };

    const salvarEdicao = async () => {
        try {
            await axios.put(`${process.env.REACT_APP_API_URL}/update/enderecoFiscal/${editando}`, dadosEdicao, {
                headers: {
                    Authorization: localStorage.getItem("token")
                }
            });
            setEditando(null);
            setDadosEdicao({});
        } catch (error) {
            console.error("Erro ao salvar endereço:", error);
        }
    };

    const formatarValor = (valor) => {
        return Number(valor || 0).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
        });
    };

    return (
        <div>
            <Header />
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                <div style={{ width: '90%', marginTop: 20 }}>
                    <div role="presentation">
                        <Breadcrumbs aria-label="breadcrumb">
                            <Link underline="hover" color="inherit" onClick={() => navigate("../dashboard")}>
                                Dashboard
                            </Link>
                            <Typography sx={{ color: 'text.primary' }}>Endereço Fiscal</Typography>
                        </Breadcrumbs>
                    </div>
                    <div>
                        <h2>Endereço Fiscal</h2>
                    </div>
                    <div>
                        <h3>Lista de Endereços Fiscais</h3>
                    </div>
                    <Box sx={{ width: "100%", marginTop: 4, marginBottom: 2 }}>

                        <TableContainer
                            component={Paper}
                            sx={{
                                borderRadius: 3,
                                boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
                                overflowX: "auto",
                            }}
                        >
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ fontWeight: 700 }}>
                                            ID
                                        </TableCell>

                                        <TableCell sx={{ fontWeight: 700 }}>
                                            Rua
                                        </TableCell>

                                        <TableCell sx={{ fontWeight: 700 }}>
                                            Número
                                        </TableCell>

                                        <TableCell sx={{ fontWeight: 700 }}>
                                            Bairro
                                        </TableCell>

                                        <TableCell sx={{ fontWeight: 700 }}>
                                            Cidade
                                        </TableCell>

                                        <TableCell sx={{ fontWeight: 700 }}>
                                            Estado
                                        </TableCell>

                                        <TableCell sx={{ fontWeight: 700 }}>
                                            CEP
                                        </TableCell>

                                        <TableCell sx={{ fontWeight: 700 }}>
                                            Complemento
                                        </TableCell>

                                        <TableCell sx={{ fontWeight: 700 }}>
                                            Valor
                                        </TableCell>

                                        <TableCell sx={{ fontWeight: 700 }}>
                                            Status
                                        </TableCell>

                                        <TableCell
                                            align="center"
                                            sx={{ fontWeight: 700 }}
                                        >
                                            Ações
                                        </TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {enderecos.map((endereco) => {
                                        const estaEditando =
                                            editando === endereco.idEnderecoFiscal;

                                        return (
                                            <TableRow
                                                key={endereco.idEnderecoFiscal}
                                                hover
                                            >
                                                <TableCell>
                                                    {endereco.idEnderecoFiscal}
                                                </TableCell>

                                                {/* RUA */}
                                                <TableCell>
                                                    {estaEditando ? (
                                                        <TextField
                                                            size="small"
                                                            value={
                                                                dadosEdicao.rua || ""
                                                            }
                                                            onChange={(e) =>
                                                                alterarCampo(
                                                                    "rua",
                                                                    e.target.value
                                                                )
                                                            }
                                                        />
                                                    ) : (
                                                        endereco.rua
                                                    )}
                                                </TableCell>

                                                {/* NÚMERO */}
                                                <TableCell>
                                                    {estaEditando ? (
                                                        <TextField
                                                            size="small"
                                                            value={
                                                                dadosEdicao.numero || ""
                                                            }
                                                            onChange={(e) =>
                                                                alterarCampo(
                                                                    "numero",
                                                                    e.target.value
                                                                )
                                                            }
                                                            sx={{ width: 90 }}
                                                        />
                                                    ) : (
                                                        endereco.numero
                                                    )}
                                                </TableCell>

                                                {/* BAIRRO */}
                                                <TableCell>
                                                    {estaEditando ? (
                                                        <TextField
                                                            size="small"
                                                            value={
                                                                dadosEdicao.bairro || ""
                                                            }
                                                            onChange={(e) =>
                                                                alterarCampo(
                                                                    "bairro",
                                                                    e.target.value
                                                                )
                                                            }
                                                        />
                                                    ) : (
                                                        endereco.bairro
                                                    )}
                                                </TableCell>

                                                {/* CIDADE */}
                                                <TableCell>
                                                    {estaEditando ? (
                                                        <TextField
                                                            size="small"
                                                            value={
                                                                dadosEdicao.cidade || ""
                                                            }
                                                            onChange={(e) =>
                                                                alterarCampo(
                                                                    "cidade",
                                                                    e.target.value
                                                                )
                                                            }
                                                        />
                                                    ) : (
                                                        endereco.cidade
                                                    )}
                                                </TableCell>

                                                {/* ESTADO */}
                                                <TableCell>
                                                    {estaEditando ? (
                                                        <TextField
                                                            size="small"
                                                            value={
                                                                dadosEdicao.estado || ""
                                                            }
                                                            onChange={(e) =>
                                                                alterarCampo(
                                                                    "estado",
                                                                    e.target.value
                                                                )
                                                            }
                                                            sx={{ width: 80 }}
                                                        />
                                                    ) : (
                                                        endereco.estado
                                                    )}
                                                </TableCell>

                                                {/* CEP */}
                                                <TableCell>
                                                    {estaEditando ? (
                                                        <TextField
                                                            size="small"
                                                            value={
                                                                dadosEdicao.cep || ""
                                                            }
                                                            onChange={(e) =>
                                                                alterarCampo(
                                                                    "cep",
                                                                    e.target.value
                                                                )
                                                            }
                                                        />
                                                    ) : (
                                                        endereco.cep
                                                    )}
                                                </TableCell>

                                                {/* COMPLEMENTO */}
                                                <TableCell>
                                                    {estaEditando ? (
                                                        <TextField
                                                            size="small"
                                                            value={
                                                                dadosEdicao.complemento ||
                                                                ""
                                                            }
                                                            onChange={(e) =>
                                                                alterarCampo(
                                                                    "complemento",
                                                                    e.target.value
                                                                )
                                                            }
                                                        />
                                                    ) : (
                                                        endereco.complemento || "-"
                                                    )}
                                                </TableCell>

                                                {/* VALOR */}
                                                <TableCell>
                                                    {estaEditando ? (
                                                        <TextField
                                                            size="small"
                                                            type="number"
                                                            value={
                                                                dadosEdicao.valor || ""
                                                            }
                                                            onChange={(e) =>
                                                                alterarCampo(
                                                                    "valor",
                                                                    e.target.value
                                                                )
                                                            }
                                                            sx={{ width: 110 }}
                                                        />
                                                    ) : (
                                                        formatarValor(endereco.valor)
                                                    )}
                                                </TableCell>

                                                {/* STATUS */}
                                                <TableCell>
                                                    <Chip
                                                        label={
                                                            endereco.ativo
                                                                ? "Ativo"
                                                                : "Inativo"
                                                        }
                                                        color={
                                                            endereco.ativo
                                                                ? "success"
                                                                : "default"
                                                        }
                                                        size="small"
                                                    />
                                                </TableCell>

                                                {/* AÇÕES */}
                                                <TableCell align="center">
                                                    {estaEditando ? (
                                                        <>
                                                            <Tooltip title="Salvar">
                                                                <IconButton
                                                                    color="success"
                                                                    onClick={
                                                                        salvarEdicao
                                                                    }
                                                                >
                                                                    <SaveIcon />
                                                                </IconButton>
                                                            </Tooltip>

                                                            <Tooltip title="Cancelar">
                                                                <IconButton
                                                                    color="error"
                                                                    onClick={
                                                                        cancelarEdicao
                                                                    }
                                                                >
                                                                    <CloseIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </>
                                                    ) : (
                                                        <Tooltip title="Editar">
                                                            <IconButton
                                                                color="primary"
                                                                onClick={() =>
                                                                    iniciarEdicao(
                                                                        endereco
                                                                    )
                                                                }
                                                            >
                                                                <EditIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </div>
            </div>
        </div>
    );
}

export default EnderecoFiscal;